import React from 'react';
import { FaRobot, FaNetworkWired, FaBrain, FaCloud, FaTools, FaChartLine } from 'react-icons/fa';
import { ServiceItemProps, ServicesContent } from '../types';

/**
 * Content for the services section
 */
export const servicesContent: ServicesContent = {
  heading: 'Our Services',
  description: 'We provide end-to-end solutions for developing, deploying, and optimizing agentic systems that transform how your organization operates.'
};

/**
 * Services data
 */
export const services: ServiceItemProps[] = [
  {
    title: 'Agent Development',
    description: 'Custom AI agents tailored to your business needs with advanced reasoning, decision-making, and action capabilities.',
    icon: React.createElement(FaRobot),
  },
  {
    title: 'Multi-Agent Systems',
    description: 'Orchestrated teams of specialized AI agents that collaborate to solve complex tasks and workflows.',
    icon: React.createElement(FaNetworkWired),
  },
  {
    title: 'Cognitive Architecture',
    description: 'Sophisticated frameworks that enable agents to reason, learn, and adapt to new situations and challenges.',
    icon: React.createElement(FaBrain),
  },
  {
    title: 'Deployment Infrastructure',
    description: 'Scalable, secure, and reliable infrastructure for hosting and operating your agentic systems in production.',
    icon: React.createElement(FaCloud),
  },
  {
    title: 'System Integration',
    description: 'Seamless integration of agentic systems with your existing software, databases, and business processes.',
    icon: React.createElement(FaTools),
  },
  {
    title: 'Performance Analytics',
    description: 'Comprehensive monitoring, analytics, and reporting tools to track and optimize agent performance.',
    icon: React.createElement(FaChartLine),
  },
];
